import { firebase, firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import getCurrentUid from '../utilities/getCurrentUid'
import { errorOfType } from '../utilities/Errors'

const addUserAnalytics = async ({ event }) => {
	const uid = getCurrentUid()
	try {
		if (uid) {
			const myEvent = { ...event, uid, createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }
			const userProfileDocRef = firestore.collection('userProfiles').doc(uid)
			await userProfileDocRef.collection('analytics').add(myEvent)
		}
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, event, exception)
	}
}

export default addUserAnalytics



// WEBPACK FOOTER //
// ./src/dataservices/addUserAnalytics.js